import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { orderNumber } = useParams();
  return (
    <div className="max-w-xl mx-auto text-center py-20 px-6">
      <CheckCircle2 size={64} className="mx-auto text-[#FFD600] mb-4" />
      <div className="font-display text-4xl uppercase mb-2">Faleminderit!</div>
      <div className="text-neutral-400 mb-1">Porosia juaj u pranua me sukses.</div>
      <div className="text-sm text-neutral-500 mb-8">Numri i porosisë: <span data-testid="order-num" className="text-[#FFD600] font-bold">{orderNumber}</span></div>
      <div className="text-sm text-neutral-400 mb-8">Do t'ju kontaktojmë së shpejti për konfirmim.</div>
      <Link to="/" className="hg-btn-primary inline-block px-6 py-3 uppercase text-sm">Kthehu në ballinë</Link>
    </div>
  );
}
